<div>
    <!-- Top bar: breadcrumb back-link left; icon actions + the table's
         Finalize/Pay CTA right. .invoice-header keeps the bar out of print. -->
    <vb-breadcrumb
        class="invoice-header"
        [trail]="crumbTrail"
        (back)="goBack()"
        (crumbSelect)="onCrumbSelect($event)">
        <div vbBreadcrumbActions class="invoice-header__actions">
            <vb-icon-button
                icon="message"
                label="Message seller"
                tipPosition="bottom"
                (clicked)="sendMessageToSeller()" />
            <vb-icon-button
                icon="history"
                label="Invoice history"
                tipPosition="bottom"
                [active]="showInvoiceHistory"
                (clicked)="toggleInvoiceHistory()" />
            <vb-icon-button
                *ngIf="
                    invoiceDetails?.currentStatus?.statusType ===
                    invoiceStatusType.PendingBuyerShippingReview
                "
                icon="truck"
                label="Shipping quote"
                tipPosition="bottom"
                [active]="showShippingQuote"
                (clicked)="onToggleShippingQuote()" />
            <span
                *ngIf="isDownloading; else downloadBtn"
                class="invoice-header__busy">
                <vb-spinner size="sm"></vb-spinner>
            </span>
            <ng-template #downloadBtn>
                <vb-icon-button
                    icon="download"
                    label="Download invoice"
                    tipPosition="bottom"
                    [disabled]="isPrinting"
                    (clicked)="downloadInvoice()" />
            </ng-template>
            <span
                *ngIf="isPrinting; else printBtn"
                class="invoice-header__busy">
                <vb-spinner size="sm"></vb-spinner>
            </span>
            <ng-template #printBtn>
                <vb-icon-button
                    icon="print"
                    label="Print invoice"
                    tipPosition="bottom"
                    tipAlign="right"
                    [disabled]="isDownloading"
                    (clicked)="printInvoice()" />
            </ng-template>
            <vb-button
                *ngIf="headerAction as action"
                [variant]="action.variant"
                size="sm"
                (clicked)="goToInvoiceActions()">
                {{ action.label }}
            </vb-button>
        </div>
    </vb-breadcrumb>
    <div
        *ngIf="isLoading"
        class="vb-spinner-box vb-spinner-box--panel margin-horizontal">
        <vb-spinner size="xl" label="Loading invoice"></vb-spinner>
    </div>
    <div *ngIf="!isLoading" class="p-relative">
        <div class="p-4 invoice-card mt-2 invoice-container">
            <div class="d-flex">
                <img
                    [ngStyle]="{'width': isMobile ? '40%' : '15%'}"
                    src="assets/viewbid/images/logo_viewbid.svg"
                    alt="vb_logo" />
            </div>
            <div [ngClass]="{'d-flex justify-content-between': !isMobile, 'd-block': isMobile}">
                <div class="d-flex">
                    <div class="d-flex" [class.row]="isMobile">
                        <div class="mt-2" [ngClass]="{'col-4': isMobile}">
                            <p class="text-grey" [ngClass]="{'fs-7': isMobile}">HST Number:</p>
                            <p class="text-grey" [ngClass]="{'fs-7': isMobile}">Company Name:</p>
                            <p class="text-grey" [ngClass]="{'fs-7': isMobile}">Address:</p>
                            <p class="text-grey" [ngClass]="{'fs-7': isMobile}" [ngStyle]="{'margin-top': isMobile ? '30%' : '65%'}">
                                Email:
                            </p>
                            <p class="text-grey" [ngClass]="{'fs-7': isMobile}">Website:</p>
                            <p class="text-grey" [ngClass]="{'fs-7': isMobile}">Contact No.</p>
                        </div>
                        <div class="mt-2" [ngClass]="{'col-8': isMobile}">
                            <p class="bold red-text ms-2" [ngClass]="{'fs-7': isMobile}">865343248</p>
                            <p class="ms-2" [ngClass]="{'fs-7': isMobile}">Viewbid Auctions</p>
                            <p class="ms-2" [ngClass]="{'fs-7, p-0, m-0': isMobile}">
                                803 Main Street<br *ngIf="!isMobile" />
                                Dartmouth, NS<br *ngIf="!isMobile" />
                                B2W 3T4
                            </p>
                            <p class="ms-2" [ngClass]="{'fs-7': isMobile}">general&#64;viewbid.ca</p>
                            <p [ngClass]="{'fs-7': isMobile}">
                                <a
                                    href="https://www.viewbid.com"
                                    class="ms-2 link-text"
                                    >www.viewbid.com</a
                                >
                            </p>
                            <p class="ms-2" [ngClass]="{'fs-7': isMobile}">+1 (902) 461-1010</p>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'mt-3': isMobile}">
                    <p class="text-grey mt-2" [ngClass]="{'fs-7': isMobile}">INVOICE NO</p>
                    <p [ngClass]="{'fs-7': isMobile}">#{{ invoiceDetails.invoice.number }}</p>
                    <span class="text-grey" [ngClass]="{'fs-7': isMobile}">PAYMENT STATUS</span><br />
                    <span
                        [ngStyle]="{'font-size': isMobile ? '12px' : '14px'}"
                        *ngIf="invoiceDetails.invoice.isPaidInFull"
                        class="badge bg-success-subtle text-success pt-1 px-4 badge-print"
                        id="payment-status"
                        >Paid</span
                    >
                    <span
                        [ngStyle]="{'font-size': isMobile ? '12px' : '14px'}"
                        *ngIf="!invoiceDetails.invoice.isPaidInFull"
                        class="badge bg-danger-subtle text-danger pt-1 px-4 badge-print"
                        >Unpaid</span
                    >
                    <p class="text-grey mt-2" [ngClass]="{'fs-7': isMobile}">DATE OF PURCHASE</p>
                    <span [ngClass]="{'fs-7': isMobile}">
                        {{ invoiceDetails.invoice.createdOn | vbDate }}
                    </span>
                    <ng-container
                        *ngIf="invoiceDetails.invoice.forfeitureAcknowledgedAt">
                        <p class="text-grey mt-2" [ngClass]="{'fs-7': isMobile}">
                            FORFEITURE ACKNOWLEDGED
                        </p>
                        <span class="red-text" [ngClass]="{'fs-7': isMobile}">
                            {{
                                invoiceDetails.invoice.forfeitureAcknowledgedAt
                                    | vbDate
                            }}
                        </span>
                    </ng-container>
                </div>
            </div>
            <div class="mt-4 d-flex">
                <div>
                    <span class="text-grey">Auction Name: </span>
                    <span class="bold">{{invoiceDetails.auction.name}}</span><br />
                    <span class="text-grey">Auction Letter: </span>
                    <span class="bold">{{invoiceDetails.auction.code}}</span><br />
                    <span class="text-grey">Username: </span>
                    <span class="bold">{{invoiceDetails.buyer.username}}</span><br />
                </div>
            </div>
            <div class="mt-4 d-flex">
                <div>
                    <span class="text-grey">BILLING INFO</span><br />
                    <div class="overflow">
                        <span class="bold"
                            >{{ invoiceDetails.buyer.firstname }}
                            {{ invoiceDetails.buyer.lastname }}</span
                        ><br />
                        <span class="text-grey"
                            >{{ invoiceDetails.billingAddress?.address1 }}
                            {{ invoiceDetails.billingAddress?.address2 }}
                            <br />
                            {{ invoiceDetails.billingAddress?.city }}
                            {{ invoiceDetails.billingAddress?.province }}
                            {{ invoiceDetails.billingAddress?.country }}
                            {{ invoiceDetails.billingAddress?.postalCode }}
                            <br />
                            <span *ngIf="invoiceDetails.buyer.telephone"
                                >Phone:
                                {{ invoiceDetails.buyer.telephone }}</span
                            ></span
                        ><br />
                        <span class="text-grey"
                            >Email:
                            {{ invoiceDetails.buyer.email }}</span
                        >
                    </div>
                </div>
                <div class="ms-5" *ngIf="invoiceDetails.invoice.isShipping">
                    <span class="text-grey">SHIPPING ADDRESS</span><br />
                    <div class="overflow">
                        <span class="bold"
                            >{{ invoiceDetails.buyer.firstname }}
                            {{ invoiceDetails.buyer.lastname }}</span
                        ><br />
                        <span class="text-grey"
                            >{{ invoiceDetails.shippingAddress?.address1 }}
                            {{ invoiceDetails.shippingAddress?.address2 }}
                            <br />
                            {{ invoiceDetails.shippingAddress?.city }}
                            {{ invoiceDetails.shippingAddress?.province }}
                            {{ invoiceDetails.shippingAddress?.country }}
                            {{ invoiceDetails.shippingAddress?.postalCode }}
                            <br />
                            <span *ngIf="invoiceDetails.buyer.telephone"
                                >Phone:
                                {{ invoiceDetails.buyer.telephone }}</span
                            ></span
                        ><br />
                        <span class="text-grey">
                            Email: {{ invoiceDetails.buyer.email }}</span
                        >
                    </div>
                </div>
                <div class="ms-5" *ngIf="!invoiceDetails.invoice.isShipping">
                    <div>
                        <span class="text-grey">PICKUP LOCATION</span><br />
                        <div>
                            <span class="text-grey bold"
                                >803 Main Street<br />Dartmouth, NS<br />B2W 3T4</span
                            ><br />
                            <a href="tel:+1-902-461-1010" class="text-grey bold">Phone: +1 (902) 461-1010</a>
                            <br />
                        </div>
                    </div>
                </div>
                <div *ngIf="this.trackingInfo?.number" class="ms-5 text-grey">
                    <div>TRACKING INFO</div>
                    <div class="lh-1">Tracking No.</div>
                    <div class="fw-bold mb-2">
                        {{ this.trackingInfo.number }}
                    </div>
                    <div class="lh-1">Method</div>
                    <div class="fw-bold mb-2">
                        {{ this.trackingInfo?.method }}
                    </div>
                    <div class="lh-1">Company</div>
                    <div class="fw-bold">
                        {{ this.trackingInfo?.company }}
                    </div>
                </div>
            </div>
            <div class="mt-4 table-responsive">
                <div class="mb-1">
                    <label id="item-details">
                        <input
                            type="checkbox"
                            name="show-details"
                            (click)="onShowDetails($event)" />
                        Item Details</label
                    >
                </div>
                <table class="table table-borderless" [ngClass]="{'table-sm': isMobile}">
                    <thead>
                        <tr>
                            <th scope="col" class="invoice-item-header" [ngClass]="{'fs-7': isMobile}">Lot #</th>
                            <th scope="col" class="invoice-item-header" [ngClass]="{'fs-7': isMobile}">
                                Product Details
                            </th>
                            <ng-container *ngIf="isShowDetails">
                                <th
                                    scope="col"
                                    class="text-end invoice-item-header"
                                    [ngClass]="{'fs-7': isMobile}">
                                    Buyer's Premium
                                </th>
                                <th
                                    scope="col"
                                    class="text-end invoice-item-header"
                                    [ngClass]="{'fs-7': isMobile}">
                                    Tax
                                </th>
                            </ng-container>
                            <th
                                scope="col"
                                class="text-end invoice-item-header"
                                [ngClass]="{'fs-7': isMobile}">
                                Unit Price
                            </th>
                            <th
                                scope="col"
                                class="text-end invoice-item-header"
                                [ngClass]="{'fs-7': isMobile}">
                                Quantity
                            </th>
                            <th
                                scope="col"
                                class="text-end invoice-item-header"
                                [ngClass]="{'fs-7': isMobile}">
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="
                                let item of invoiceDetails.items;
                                let i = index
                            ">
                            <td [ngClass]="{'fs-7': isMobile}">{{ getLotNumber(item) }}</td>
                            <td class="d-flex flex-column"
                                data-bs-toggle="tooltip"
                                title="{{ item.name }}"
                                [ngClass]="{'fs-7': isMobile}">
                                <span>{{ limitChars.limitChars(isMobile ? 20 : 30, item.name) }}</span>
                                <span
                                    class="text-grey"
                                    *ngIf="item.lotAttributes"
                                    >{{ item.lotAttributes }}</span>
                            </td>
                            <ng-container *ngIf="isShowDetails">
                                <td class="text-end" [ngClass]="{'fs-7': isMobile}">
                                    ${{
                                        item.buyerPremiumAmount
                                            | number: "1.2-2"
                                    }}
                                </td>
                                <td class="text-end" [ngClass]="{'fs-7': isMobile}">
                                    ${{
                                        item.taxAmount | number: "1.2-2"
                                    }}
                                </td>
                            </ng-container>
                            <td class="text-end" [ngClass]="{'fs-7': isMobile}">
                                ${{ item.price | number: "1.2-2" }}
                            </td>
                            <td class="text-end" [ngClass]="{'fs-7': isMobile}">{{ item.quantity }}</td>
                            <td class="text-end" [ngClass]="{'fs-7': isMobile}">
                                ${{
                                    calculateTotalItemAmount(item)
                                        | number: "1.2-2"
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex">
                <div [ngClass]="{'col-8': !isMobile, 'col-4': isMobile}"></div>
                <div [ngClass]="{'col-4': !isMobile, 'col-8': isMobile}" class="pe-1">
                    <div class="d-flex justify-content-between">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Subtotal</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}"
                            >${{
                                invoiceDetails.invoice.itemsSubtotal
                                    | number: "1.2-2"
                            }}</span
                        >
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Buyer's Premium</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}"
                            >${{
                                invoiceDetails.invoice.buyerPremiumTotal
                                    | number: "1.2-2"
                            }}</span
                        >
                    </div>
                    <div
                        class="d-flex justify-content-between mt-2"
                        *ngIf="invoiceDetails.invoice.isShipping">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Shipping</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}">{{
                            shippingTotal === 0
                                ? "TBD"
                                : "$" + (shippingTotal | number: "1.2-2")
                        }}</span>
                    </div>
                    <div
                        class="d-flex justify-content-between mt-2"
                        *ngIf="invoiceDetails.invoice.taxesSubtotal">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Tax</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}"
                            >${{
                                invoiceDetails.invoice.taxesSubtotal
                                    | number: "1.2-2"
                            }}</span
                        >
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between mt-2">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Total</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}"
                            >${{
                                invoiceDetails.invoice.totalAmount
                                    | number: "1.2-2"
                            }}</span
                        >
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between success-text">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Amount Paid</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}"
                            >${{
                                invoiceDetails.invoice.amountPaid
                                    | number: "1.2-2"
                            }}</span
                        >
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between red-text">
                        <span class="bold" [ngClass]="{'fs-7': isMobile}">Amount Owing</span>
                        <span class="bold ms-4 text-end pe-1" [ngClass]="{'fs-7': isMobile}"
                            >${{
                                invoiceDetails.invoice.amountDue
                                    | number: "1.2-2"
                            }}</span
                        >
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <span class="text-dark-grey fw-bold">INFO:</span>
                <p class="text-grey">
                    {{ invoiceDetails.auction.invoiceInfo }}
                </p>
            </div>
            <div
                class="mt-4"
                *ngIf="
                    invoiceDetails.invoiceNotes &&
                    invoiceDetails.invoiceNotes.length > 0
                ">
                <span class="text-grey bold">NOTES:</span><br />
                <div class="mt-2 p-2 notes-container">
                    <div
                        *ngFor="
                            let note of invoiceDetails.invoiceNotes;
                            let last = last
                        ">
                        <span class="notes-text fw-semibold m-0 p-0">
                            {{ note.instruction }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <!-- Invoice history drawer — profile redesign chrome: token panel,
             vb-icon-button close, timeline of mono dates + plain-language
             status labels (never the raw workflow status string). -->
        <div *ngIf="showInvoiceHistory" class="right-panel vb-ihist">
            <div>
                <div class="vb-ihist__head">
                    <h6 class="vb-ihist__title">Invoice history</h6>
                    <vb-icon-button
                        icon="close"
                        label="Close invoice history"
                        [size]="32"
                        (clicked)="toggleInvoiceHistory()" />
                </div>
                <div class="vb-ihist__list">
                    <ng-container *ngFor="let history of invoiceHistory">
                        <div
                            class="vb-ihist__item"
                            *ngIf="history.type === 'status'; else paymentInfo">
                            <span class="vb-ihist__date">{{
                                history.createdOn | vbDate
                            }}</span>
                            <span class="vb-ihist__label">{{
                                statusLabel(history.statusType)
                            }}</span>
                        </div>

                        <ng-template #paymentInfo>
                            <div class="vb-ihist__item">
                                <span class="vb-ihist__date">{{
                                    history.paymentDate | vbDate
                                }}</span>
                                <span class="vb-ihist__row">
                                    <span class="vb-ihist__label">
                                        Payment made
                                    </span>
                                    <span class="vb-ihist__amount">
                                        ${{
                                            history.amountPaid
                                                | number: "1.2-2"
                                        }}
                                    </span>
                                </span>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </div>
        <div *ngIf="showShippingQuote" class="right-panel fs-7">
            <div
                *ngIf="!isApproveShippingQuote"
                class="d-flex flex-column h-100 align-content-between">
                <div>
                    <div
                        class="d-flex justify-content-between align-items-center">
                        <h6 class="text-decoration-underline">
                            Shipping Quote
                        </h6>
                        <button
                            class="btn btn-icon btn-ghost-dark pb-2"
                            type="button"
                            (click)="onToggleShippingQuote()">
                            <i
                                style="font-size: 1.5em"
                                role="button"
                                class="fa fa-close"></i>
                        </button>
                    </div>
                    <p class="fs-7">Information on the shipping quote below:</p>
                    <div class="d-flex justify-content-between mb-2">
                        <div>Number of items</div>
                        <div>{{ invoiceDetails.shipping?.numPieces }}</div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div>Number of packages</div>
                        <div>0</div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div>Weight (kg)</div>
                        <div>{{ invoiceDetails.shipping?.weight }}</div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div>Method</div>
                        <div>{{ invoiceDetails.shipping?.method }}</div>
                    </div>
                    <div
                        class="d-flex justify-content-between mb-2 border-bottom border-1 pb-3">
                        <div>Shipping Tax (optional)</div>
                        <div>0</div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="fw-bold">Shipping total</div>
                        <div>
                            ${{
                                invoiceDetails.shipping?.subtotal
                                    | number: "1.2-2"
                            }}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="fw-bold">Tax</div>
                        <div>
                            ${{ getShippingTaxAmount() | number: "1.2-2" }}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="fw-bold">Total to be added:</div>
                        <div>
                            ${{
                                invoiceDetails.invoice.amountDue
                                    | number: "1.2-2"
                            }}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div>Total cost incl. shipping:</div>
                        <div>
                            ${{
                                invoiceDetails.invoice.totalAmount
                                    | number: "1.2-2"
                            }}
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-between mb-2 text-vb-green">
                        <div class="fw-bold">Amount Paid:</div>
                        <div>
                            ${{
                                invoiceDetails.invoice.amountPaid
                                    | number: "1.2-2"
                            }}
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-between mb-3 text-vb-red">
                        <div class="fw-bold">Amount Owing:</div>
                        <div>
                            ${{
                                invoiceDetails.invoice.amountDue
                                    | number: "1.2-2"
                            }}
                        </div>
                    </div>
                    <p class="fs-7 lh-sm">
                        We strive to always offer the best price possible. For
                        the reason we can only hold the above price for 48hrs.
                    </p>
                    <p class="fs-7 lh-sm">
                        If you have any disputes or questions around the above
                        quote, please contact our office and we'll be happy to
                        assist you.
                    </p>
                    <p class="fs-7 lh-sm">
                        Call:
                        <a
                            href="tel:9024611010"
                            class="link-text"
                            title="+1 (902) 461-1010"
                            >+1 (902) 461-1010</a
                        ><br />
                        Email:
                        <a
                            href="mailto:quotations@viewbid.com"
                            class="link-text"
                            title="quotations&#64;viewbid.com"
                            >quotations&#64;viewbid.com</a
                        >
                    </p>
                </div>
                <div class="text-center mt-auto pb-3">
                    <button
                        class="rounded bold w-75 vb-green-btn p-2 fw-semibold fs-6"
                        (click)="onApproveShippingQuote()">
                        Approve Quote
                    </button>
                </div>
            </div>
            <div
                *ngIf="isApproveShippingQuote"
                class="position-absolute h-100 text-center">
                <p class="red-text fs-7 mb-1 fw-bold lh-sm">
                    Payment needed to complete the invoice
                </p>
                <p class="red-text fs-6 fw-bold">
                    ${{ invoiceDetails.invoice.amountDue | number: "1.2-2" }}
                </p>
                <div *ngIf="paymentMethods?.length">
                    <p class="fw-bold lh-sm">
                        Please select your payment method.
                    </p>
                </div>
                <div
                    *ngFor="let paymentMethod of paymentMethods; let i = index"
                    class="payment-method mb-3">
                    <div
                        class="d-flex justify-content-between border border-1 rounded p-2 align-items-center"
                        [class.cursor-pointer]="!isCardExpired(paymentMethod.expirationDate)"
                        [class.opacity-50]="isCardExpired(paymentMethod.expirationDate)"
                        [ngClass]="{
                            checked:
                                selectedPaymentCard?.customerPaymentProfileId ===
                                paymentMethod?.customerPaymentProfileId
                        }">
                        <input
                            *ngIf="!isCardExpired(paymentMethod.expirationDate)"
                            type="radio"
                            name="paymentMethod"
                            (click)="onSelectPaymentMethod(i)" />
                        <i
                            class="fa-brands fs-4"
                            [ngClass]="
                                getCardTypeClass(
                                    paymentMethod.cardType.toLowerCase()
                                )
                            "
                            style="color: rgb(0, 103, 179)"></i>
                        <div>
                            {{ paymentMethod.cardNumber }}
                        </div>
                        <div>
                            <span>Exp: {{ paymentMethod.expirationDate }}</span>
                            <span
                                *ngIf="isCardExpired(paymentMethod.expirationDate)"
                                class="text-danger fw-semibold ms-2"
                                title="This card is expired and cannot be used for payment">
                                <i class="fa-solid fa-triangle-exclamation me-1"></i>Expired
                            </span>
                        </div>
                    </div>
                </div>
                <button
                    class="rounded bold w-75 vb-blue-btn p-2 fw-semibold fs-6 mb-2"
                    (click)="onPayNow()"
                    [ngClass]="{ disabled: selectedPaymentCard === null }"
                    [disabled]="selectedPaymentCard === null ? true : null">
                    Pay Now
                </button>
                <button
                    class="rounded bold w-75 vb-red-btn p-2 fw-semibold fs-6"
                    (click)="onCancelShippingQuote()">
                    Go Back
                </button>
            </div>
        </div>
    </div>
</div>
